import React, { useEffect, useState } from "react";
import { useSearch } from "../../../Contexts/SearchContext";
import { getActiveFilters, setFilterState } from "../../../../helpers";
import "./FilterDrawerToggle.scss";

const FilterDrawerToggle = ({ data, index }) => {
  const { state, dispatch } = useSearch();
  const { componentElement } = state;

  const updateFilters = (event) => {
    let toggleSwitch = event.target;

    setFilterState(toggleSwitch.value, componentElement, toggleSwitch.checked);

    dispatch({
      type: "UPDATE_SELECTED_FILTERS",
      payload: getActiveFilters(componentElement),
    });
  };

  if (data) {
    return (
      <div className="cmp-toggle__item toggle-checkbox-wrapper">
        <div className="cmp-toggle__dropdown-heading">
          <div className="cmp-toggle__title">{data.label}</div>
        </div>
        <input
          className="toggle-checkbox"
          type="checkbox"
          id={`toggle-${index}`}
          value={data.tagId}
          data-heading-filter-title={data.label}
          onChange={updateFilters}
        />
        <label className="slider" htmlFor={`toggle-${index}`}></label>
      </div>
    );
  } else {
    return <></>;
  }
};

export default FilterDrawerToggle;
